import styled from '@emotion/styled';

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px;
  color: #7c7c7f;
  border: 1px solid #cad3dd;
  width: 100%;
  height: 100%;
`;
